import styled from 'styled-components/native';

const CenteredView = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export default CenteredView;
